// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';

export type Props = {
  onUserChange: Function,
};

const SupplierForm = ({onUserChange}: Props) => (
  <div className="supplierForm">
    <form>
      <div className="content-section box">
        <Field
          name="name"
          label="Namn"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="identifier"
          label="Org nr"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="address"
          label="Adress"
          onChange={onUserChange}
          component={TextAreaFormInput}
          type="text" />
        <Field
          name="contact"
          label="Kontakt"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="phone"
          label="Telefonnummer"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="email"
          label="Email"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="note"
          label="Notering"
          onChange={onUserChange}
          component={TextAreaFormInput}
          type="text" />
      </div>
    </form>
  </div>
);

export default reduxForm({
  form: 'supplier',
  enableReinitialize: true,
})(SupplierForm);



// WEBPACK FOOTER //
// ./src/components/SupplierForm/SupplierForm.js